import React from 'react';
import { View } from 'react-native';

import styles from './styles';
import Text from '../../react-component/textComponent';

export default (props) => {
    const { title = 'Nenhum registro selecionado' } = props;

    return (
        <View {...props} style={[props.style, styles.emptyState]}>
            <Text style={styles.emptyStateText}>{title}</Text>
        </View>
    );
};
